import React, { useState } from "react";

//styles
import styled from "styled-components";
import "./styles.css";
import "./reactVisStyles.css";

//components
import Navigation from "../navbar";
import Heatmap from "./heatmap";
import ViewsByDate from "./viewsByDate";
import ViewsByStore from "./viewsByStore";
import ViewsByBrand from "./viewsByBrand";
import ViewsByPrice from "./viewsByPrice";
import ViewsByLens from "./viewsByLense";
import ViewsByColor from "./viewsByColor";
import FrameInfoTable from "./frameInfo";

//models
import { IDates } from "../../models/dates";

//helpers
import moment, { Moment } from "moment";

const DashBoard = () => {
  const [dates, setStateDates] = useState<IDates>({
    startDate: null,
    endDate: null
  });

  return (
    <>
      <Navigation setStateDates={setStateDates} dates={dates} />
      <div>
        <Container>
          <SingleRowOverflow>
            <Heatmap />
          </SingleRowOverflow>
          <Row>
            <ViewsByDate />
            <ViewsByStore />
          </Row>
          <Row>
            <ViewsByBrand />
            <ViewsByPrice />
          </Row>
          <Row>
            <ViewsByLens />
            <ViewsByColor />
          </Row>
          <SingleRow>
            <FrameInfoTable />
          </SingleRow>
        </Container>
      </div>
    </>
  );
};

export default DashBoard;

const Container = styled.div`
  display: block;
  flex-wrap: wrap;
  justify-content: center;
  width: 95%;
  max-width: 1352px;
  margin: 60px auto;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  justify-content: flex-start;
  overflow-x: scroll;
  @media (min-width: 570px) {
    overflow-x: visible;
    justify-content: space-between;
  }
`;

const SingleRow = styled.div`
  border-radius: 6px;
  display: flex;
  margin-bottom: 40px;
  width: 100%;
  justify-content: flex-start;
  /* overflow-x: scroll;
  overflow-y: hidden; */
  position: relative; /* allows the filter button to be positioned relative to this container box */
  @media (min-width: 800px) {
    justify-content: center;
  }
`;

const SingleRowOverflow = styled.div`
  border-radius: 6px;
  display: flex;
  margin-bottom: 40px;
  width: 100%;
  justify-content: flex-start;

  overflow-x: scroll;
  @media (min-width: 600px) {
    overflow-x: visible;
  }
`;
